<div class="robot-rules-container">
  <div class="block extra" *ngIf="type === EventType.Inquiry">
    <nz-alert nzShowIcon [nzMessage]="'robot.rule.inquiry_tip' | translate"></nz-alert>
    <!-- <i nz-icon nzType="exclamation-circle" nzTheme="outline" style="margin-right: 8px"></i>
    <span class="tip">{{ "robot.rule.inquiry_tip" | translate }}</span> -->
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "robot.message.title.condition" | translate }}</div>
    <div class="block-list">
      <div class="v4-layout-field">
        <ng-container [ngSwitch]="type">
          <!--          预订-->
          <ng-container *ngSwitchCase="EventType.ReplyToEvents">
            <span class="v4-layout-field-label">{{ "robot.rule.condition.label_event" | translate }}</span>
            <div class="v4-layout-field-control">
              <div class="v4-layout-field-row">
                <nz-select
                  nzSize="large"
                  [(ngModel)]="event"
                  [nzDropdownMatchSelectWidth]="false"
                  [nzOptions]="eventOptions">
                </nz-select>
              </div>
            </div>
          </ng-container>
          <!--          入住、退房-->
          <ng-container *ngSwitchCase="EventType.SendOnSchedule">
            <span class="v4-layout-field-label">{{ "robot.rule.condition.label_event" | translate }}</span>
            <div class="v4-layout-field-control">
              <ng-container [ngSwitch]="event">
                <ng-container *ngSwitchCase="'specific_day_of_week'">
                  <div class="v4-layout-field-row">
                    <widget-schedule-on-a-specific-day
                      [(value)]="specific"
                      [(at)]="at"></widget-schedule-on-a-specific-day>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'after_new_reservation'">
                  <div class="v4-layout-field-row">
                    <nz-select
                      class="mr-2"
                      nzSize="large"
                      [(ngModel)]="afterHours"
                      [nzOptions]="listOfAfterResvOption"
                      [nzDropdownMatchSelectWidth]="false"></nz-select>
                    <span>
                      {{ "automatiion-message_rules_html_after_new_resv_made" | translate }}
                      <!-- after a new reservation was made -->
                    </span>
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <div class="v4-layout-field-row">
                    <nz-select
                      *ngIf="displayCheckDaySelect"
                      class="mr-2"
                      nzSize="large"
                      [(ngModel)]="days"
                      [nzDropdownMatchSelectWidth]="false"
                      [nzOptions]="listOfDayOptions"></nz-select>

                    <span class="mr-2">{{ nodeTypeName }}</span>

                    <nz-select
                      nzSize="large"
                      [(ngModel)]="at"
                      [nzDropdownMatchSelectWidth]="false"
                      [nzOptions]="listOfTimeOptions"
                      [nzCustomTemplate]="formatTimeTpl"></nz-select>
                    <ng-template #formatTimeTpl let-selected>
                      <!-- 之所以加一个日期前缀，是因为 dateformat 接受的是一个有效的日期格式，仅有时间不是一个有效的格式，所以这里利用一个随机日期将其拼接完整 -->
                      {{ "2023-11-11T" + selected.nzLabel | dateformat: [null, "hm"] }}
                    </ng-template>
                  </div>
                  <div class="v4-layout-field-extra" *ngIf="event === 'before_checkin'">
                    <span class="desc">
                      {{ "automation.message_rule.before_checkin.tip" | translate }}
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
          <!--          ai智能识别-->
          <ng-container *ngSwitchCase="EventType.Inquiry">
            <span class="v4-layout-field-label">
              {{ "automation.message_rule.label.question" | translate }}
              <!-- 问题 -->
            </span>
            <div class="v4-layout-field-control">
              <div class="v4-layout-field-row">
                <nz-select
                  nzSize="large"
                  [nzOptions]="eventOptions"
                  [(ngModel)]="inquiryId"
                  [nzDropdownMatchSelectWidth]="false">
                </nz-select>
              </div>
            </div>
          </ng-container>
          <!--          关键词识别-->
          <ng-container *ngSwitchCase="EventType.Keyword">
            <span class="v4-layout-field-label">
              {{ "automation.message_rule.label.pattern" | translate }}
              <!-- 匹配模式 -->
            </span>
            <div class="v4-layout-field-control">
              <div class="v4-layout-field-row">
                <nz-radio-group [(ngModel)]="keywordCondition">
                  <label *ngFor="let opt of eventOptions" nz-radio [nzValue]="opt.value">{{ opt.label }}</label>
                </nz-radio-group>
              </div>
              <div class="v4-layout-field-extra">
                <input
                  type="text"
                  nz-input
                  nzSize="large"
                  [placeholder]="'automation.message_rule.control.pattern.placeholder' | translate"
                  [(ngModel)]="keyword" />
                <div class="desc mt-2">
                  {{ "automation.message_rule.control.pattern.desc" | translate }}
                  <!-- 多个关键词请使用逗号分隔 -->
                </div>
              </div>
            </div>
          </ng-container>
          <!--          兜底回复-->
          <ng-container *ngSwitchCase="EventType.Underwriting">
            <span class="v4-layout-field-label">
              {{ "automation.message_rule.label.type" | translate }}
              <!-- 消息类型 -->
            </span>
            <div class="v4-layout-field-control">
              <div class="v4-layout-field-row">
                <nz-radio-group [(ngModel)]="fallbackCondition">
                  <label *ngFor="let opt of eventOptions" nz-radio [nzValue]="opt.value">{{ opt.label }}</label>
                </nz-radio-group>
              </div>
              <div class="v4-layout-field-extra">
                <span class="desc">
                  {{ "automation.message_rule.control.type.desc" | translate }}
                  <!-- 首条消息指距离房客上一条消息间隔超过30分钟 -->
                </span>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <!-- 渠道 -->
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_channel" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              class="w-full placeholder-dark"
              nzSize="large"
              nzMode="multiple"
              [(ngModel)]="channel"
              (ngModelChange)="onSelectChannels($event)"
              [nzPlaceHolder]="'word.all' | translate"
              [nzOptions]="listOfChannelOption"></nz-select>
          </div>
        </div>
      </div>
      <!-- 账号 -->
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_channel_account" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              class="w-full placeholder-dark"
              nzSize="large"
              nzMode="multiple"
              [(ngModel)]="account"
              [nzPlaceHolder]="'word.all' | translate"
              [nzOptions]="listOfChannelAccountOption"></nz-select>
          </div>
        </div>
      </div>

      <!-- 房间 -->
      <widget-rule-form-item-house-picker
        [data]="$any(properties)"
        (onChange)="properties = $event"></widget-rule-form-item-house-picker>

      @if (displayNights || displaySettings) {
        <!-- limit   -->
        <div class="v4-layout-field">
          <div class="v4-layout-field-label">{{ "automation-message-rules_html_label_limit" | translate }}</div>
          <div class="v4-layout-field-control">
            <widget-limit
              [(ngModel)]="limit"
              [showBookedBeforeDay]="type === EventType.ReplyToEvents"
              [showNoLeftReview]="displaySettings"></widget-limit>
          </div>
        </div>
      }

      <!-- nights -->
      <!-- <div class="v4-layout-field" *ngIf="displayNights">
        <div class="v4-layout-field-label">
          {{ "automation-msg_rules_html_w_nights" | translate }}
        </div>

        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <widget-nights [(value)]="nights"></widget-nights>
          </div>
        </div>
      </div> -->

      <!-- settings -->
      <!-- <div class="v4-layout-field" *ngIf="displaySettings">
        <div class="v4-layout-field-label">
          {{ "word.set" | translate }}
        </div>

        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <label nz-checkbox [(ngModel)]="limitSettings">
              {{ "automation-msg_rules_html_set_condition" | translate }}
            </label>
          </div>
        </div>
      </div> -->

      <!--      阶段-->
      <div
        class="v4-layout-field"
        *ngIf="[EventType.Inquiry, EventType.Keyword, EventType.Underwriting].includes(type)">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_stage" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-checkbox-group
              [(ngModel)]="listOfStageOption"
              (ngModelChange)="onSelectStage($event)"></nz-checkbox-group>
          </div>
        </div>
      </div>

      <!--时段-->
      <div
        class="v4-layout-field"
        *ngIf="[EventType.Inquiry, EventType.Keyword, EventType.Underwriting].includes(type)">
        <span class="v4-layout-field-label">
          {{ "automation.message_rule.label.range" | translate }}
          <!-- 时段 -->
        </span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-time-picker
              nzSize="large"
              [(ngModel)]="period.start"
              [nzFormat]="use12Hr ? 'hh:mma' : 'HH:mm'"></nz-time-picker>
            <span class="ml-md mr-md">~</span>
            <nz-time-picker
              nzSize="large"
              [(ngModel)]="period.end"
              [nzFormat]="use12Hr ? 'hh:mma' : 'HH:mm'"></nz-time-picker>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "robot.message.title.action" | translate }}</div>
    <div class="block-list">
      <div class="v4-layout-field" *ngIf="type !== EventType.SendOnSchedule">
        <span class="v4-layout-field-label">{{ "robot.rule.action.label_time" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span class="node-type mr-3" *ngIf="!isInternational">{{ nodeTypeName }}</span>
            <host-cascaded-time-picker-v2
              size="large"
              [listOfOptions]="listOfDelayTimeOptions"
              [(ngModel)]="delayTime"></host-cascaded-time-picker-v2>
            <span class="node-type ml-3" *ngIf="isInternational">{{ nodeTypeName }}</span>
          </div>
          <div class="v4-layout-field-extra">
            <span class="desc">{{ "robot.rule.action.msg_delay_tip1" | translate }}</span>
          </div>
        </div>
      </div>

      <!-- 内容 -->
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.action.label_content" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row relative" hostDragFileContainer (onDropped)="onUploadFiles($event)">
            <textarea
              #textarea
              [ngClass]="{
                'pb-[80px]': contentImage?.small_url,
                'pb-[45px]': !contentImage
              }"
              rows="10"
              nz-input
              nzAutosize
              [(ngModel)]="content"
              [placeholder]="'robot.rule.action.placeholder_content' | translate"></textarea>
            <div class="absolute bottom-[1px] left-[10px] right-[20px] py-[10px] bg-white">
              <div class="relative w-[50px] h-[35px] mb-[10px]" *ngIf="contentImage?.small_url as smallUrl">
                <img
                  [hostImgPreview]="contentImage.large_url"
                  [src]="smallUrl"
                  class="w-full h-full rounded-[4px] cursor-pointer"
                  alt="" />
                <span
                  class="absolute -right-[6px] -top-[6px] text-[13px] cursor-pointer"
                  nz-icon
                  nzType="close-circle"
                  nzTheme="fill"
                  (click)="contentImage = null"></span>
              </div>
              <div class="flex flex-row items-center">
                <v4-custom-upload class="mr-[10px]" (onFilesSelected)="onUploadFiles($event)">
                  <img
                    class="w-[20px] h-[20px] cursor-pointer"
                    src="/assets/v4/icon-img.svg"
                    alt="Attach a image"
                    title="Attach a image" />
                </v4-custom-upload>

                <host-dyn-content-picker
                  [listOfDynContentOption]="listOfDynContentOption"
                  (onSelect)="onSelectDynContent($event)"></host-dyn-content-picker>
              </div>
            </div>
          </div>
          <div class="v4-layout-field-extra">
            <div class="w-[150px]">
              <host-quick-msg-picker (onSelect)="onSelectQuickMsgOfAction($event)"></host-quick-msg-picker>
            </div>
          </div>
          <div class="sub-control flex"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "robot.message.title.rule_name" | translate }}</div>
    <div class="block-list">
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ "word.name" | translate }}
          <!-- Name -->
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <input
              type="text"
              nz-input
              nzSize="large"
              [(ngModel)]="name"
              [placeholder]="'automation-message-rules_html_ph_name' | translate" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row items-center justify-between pt-[30px]">
    <div class="left">
      <button nzSize="large" nz-button *ngIf="type === EventType.Inquiry" (click)="onClickTestRule()">
        {{ "robot.rule.operate.test" | translate }}
      </button>
      <a nz-button nzType="link" *ngIf="!isInternational && type === EventType.Keyword" (click)="onClickPriorityRule()">
        {{ "automation.message_rule.footer.priority.tip" | translate }}
        <!-- 了解规则的优先级 -->
      </a>
    </div>
    <div class="right">
      <button class="mr-3" nz-button nzSize="large" (click)="onCancel()">{{ "word.cancel" | translate }}</button>
      <button nz-button nzSize="large" nzType="primary" (click)="onSave()">{{ "word.save" | translate }}</button>
    </div>
  </div>
</div>
